// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_8a-0";
export var optionCard = "_8a-1";